import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	triggerButtonGeneric: {
		id: 'native-issue-table.common.issue-cells.versions.trigger-button-generic',
		defaultMessage: 'See more versions for ‘{fieldName}‘',
		description: 'Label for trigger button to open a dialog with a list of additional versions',
	},
});
